import React, { useState, useEffect } from "react";
import { getInsurancePlans } from "../APIs/dropdownApi";

const InsuranceDropdown = ({ value, onChange }) => {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const data = await getInsurancePlans();
        setPlans(data);
      } catch (error) {
        console.error("Error fetching insurance plans:", error);
      }
    };
    fetchPlans();
  }, []);

  return (
    <select
      value={value}
      onChange={(e) => {
        const selectedPlan = plans.find((p) => p.planName === e.target.value);
        onChange(selectedPlan || { planName: "", planTypes: [] });
      }}
      className="border rounded p-2 w-full"
      required
    >
      <option value="">Select Insurance Plan</option>
      {plans.map((plan) => (
        <option key={plan.id} value={plan.planName}>
          {plan.planName}
        </option>
      ))}
    </select>
  );
};

export default InsuranceDropdown;
